import React from 'react'
import { AuthProvider } from './auth-provider'
import { AuthProviderMock } from './auth-provider.mock'
import { environment } from '../../environment'

interface AuthWrapperProps {
  children: React.ReactNode
}

// This component chooses the appropriate auth provider based on environment
export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  // Use the mock provider in test environments for e2e tests
  // This ensures consistent auth state during testing
  if (environment.test) {
    return <AuthProviderMock>{children}</AuthProviderMock>
  }

  // Use the real provider in all other environments
  return <AuthProvider>{children}</AuthProvider>
}
